// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Collaborators from '../components/Collaborators';
import {actions as AccountsActions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    collaborators: state.accountsConfig.collaborators,
    saveSuccess: state.accountsConfig.saveSuccess,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...AccountsActions,
      },
      dispatch
    )
)(Collaborators);
